import { AttendanceGroupListQueryRequest } from "../../../../../network/attendance/Attendance";
import { InputDataList } from "../../../../components/modal/FormModal";

const OrderByOptions: {
  value: `${AttendanceGroupListQueryRequest["orderBy"]}`;
  label: string;
}[] = [
  {
    value: "unityId",
    label: "Unidad",
  },
  {
    value: "ownerUid",
    label: "Operador",
  },
  {
    value: "typeOfDay",
    label: "Tipo de trabajo",
  },
  {
    value: "timestamp",
    label: "Hora",
  },
];

const OrderOptions: {
  value: `${AttendanceGroupListQueryRequest["order"]}`;
  label: string;
}[] = [
  {
    value: "asc",
    label: "Ascendente",
  },
  {
    value: "desc",
    label: "Descendente",
  },
];

export const FilterAttendanceInputList: InputDataList = [
  {
    name: "orderBy",
    type: "select",
    label: "Ordenar por: ",
    hidden: false,
    options: OrderByOptions,
    cleanable: false,
  },
  {
    name: "order",
    type: "select",
    label: "Orden",
    hidden: false,
    options: OrderOptions,
    cleanable: false,
  },
];
